// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"0a6efe7d","398":"a1dd4d74"}[chunkId] + ".chunk.js";
};